import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { contact } from './contact';
import { RoomReservation } from '../types/entities/RoomReservation';
import { statuses } from './statuses';
import { roomType } from './roomType';
import { accommodationReservation } from './accommodationReservation';
import { DateField } from '../components/Table/fields/DateField';
import { BooleanField } from '../components/Table/fields/BooleanField';
import { FloatField } from '../components/Table/fields/FloatField';
import {SPNumberField} from "../components/Table/fields/SPNumberField";
import {SPSelectField} from "../components/Table/fields/SPSelectField";

export const room: SchemaWithClient<any> = {
  name: 'Rooms',
  pluralName: 'Rooms',
  viewTable: 'rooms',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    room_type: {
      name: 'Room Type',
      fieldRenderer: SelectField.tableAdapter(roomType),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(roomType),
      switchboard: true,
      url: roomType.client.getAllPath,
      tempSchema: roomType,
    },
    room_size: {
      name: 'Room Size',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    quantity: {
      name: 'Room Count',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    price_per_night: {
      name: 'Price / Night',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    price_per_person_per_night: {
      name: 'Price / Person / Night',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    currency: {
      name: 'Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/rooms'),
};
